export const episodeAnalysis = {
  "silicon-valley-101/6a13923cfe904f3873c51d2b": {
    "generated_at": "2026-06-02T06:02:52.470Z",
    "source_id": "silicon-valley-101",
    "episode_id": "6a13923cfe904f3873c51d2b",
    "title": "E238｜聊聊Harness时代AI-First的组织架构：从信任人到信任AI",
    "source_url": "https://www.xiaoyuzhoufm.com/episode/6a13923cfe904f3873c51d2b",
    "transcript": {
      "transcript_source": "local_asr_generated",
      "official_transcript_found": false,
      "transcript_status": "completed",
      "transcript_segments": 481,
      "source_records": 523,
      "audio_sha256": "f6e786c18125aa134e91809d363124bb1b7d1563741bdc1da1e4ded24a12f124",
      "note": "Public Xiaoyuzhou HTML exposes transcript.mediaId but not transcript sentences; transcript is local ASR generated from public audio."
    },
    "topic_map": [
      {
        "id": "topic-01",
        "title": "Harness 从 prompt/context 工程扩展为动态系统工程",
        "time_range": "00:02:32-00:08:10",
        "evidence": [
          {
            "record_id": "xy_timeline_001",
            "source_kind": "timeline",
            "start_ms": 152000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "f98f3d1323a5e58c8b38e6f863de68cb092eb93289166fa9e5d4b93c63e13668"
          },
          {
            "record_id": "asr_segment_0024",
            "source_kind": "transcript_segment",
            "start_ms": 162980,
            "end_ms": 173140,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "8bf5f4070ed252d864db9fcff408117bc02d9612eed27f07ecdebfc0d81190ca"
          }
        ]
      },
      {
        "id": "topic-02",
        "title": "AI-first 不是加工具，而是重构流程和组织",
        "time_range": "00:09:53-00:14:01",
        "evidence": [
          {
            "record_id": "xy_timeline_006",
            "source_kind": "timeline",
            "start_ms": 593000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "84c6ef3889b9366e8d074d53412444456c7ea6abb7a39192b1d5d59ddad16028"
          },
          {
            "record_id": "asr_segment_0092",
            "source_kind": "transcript_segment",
            "start_ms": 600000,
            "end_ms": 609200,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "007b55fd67f0eb4f0738ccb3835011d5f6f0de10d673afc9115788154c4b3ddf"
          }
        ]
      },
      {
        "id": "topic-03",
        "title": "Agent-driven CI/CD、bug triage 与 AutoFixing",
        "time_range": "00:19:12-00:25:47",
        "evidence": [
          {
            "record_id": "xy_timeline_009",
            "source_kind": "timeline",
            "start_ms": 1152000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "9798a274b4f944096eb773eb9b6ea5477bfc4e88fbf46512b03075e643fecaba"
          },
          {
            "record_id": "asr_segment_0143",
            "source_kind": "transcript_segment",
            "start_ms": 1152420,
            "end_ms": 1158360,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "43a15f90f96abd21e0a5c243f03d6dc4aaf03ecd81f32a2d2f4982270b4f4309"
          }
        ]
      },
      {
        "id": "topic-04",
        "title": "产品与市场节奏反转，开发能力开始快于市场消化",
        "time_range": "00:38:22-00:43:05",
        "evidence": [
          {
            "record_id": "xy_timeline_016",
            "source_kind": "timeline",
            "start_ms": 2302000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "cf2509e813e23247cd08d8c0aa16861124a72ce60d6702398bf88013cdde39d4"
          },
          {
            "record_id": "asr_segment_0209",
            "source_kind": "transcript_segment",
            "start_ms": 1856640,
            "end_ms": 1866680,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "db6f10b6c7d2aec7c5523a89002a854fa43a58d7e34022f4ba3740cea1df5fb6"
          }
        ]
      },
      {
        "id": "topic-05",
        "title": "组织信任从人转向 AI，产品经理角色被拆解",
        "time_range": "00:47:47-00:52:00",
        "evidence": [
          {
            "record_id": "xy_timeline_018",
            "source_kind": "timeline",
            "start_ms": 2867000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "26e09757e7bf57035a178e2028cdddefd169580ed9aae52c40fb8d7133f3d711"
          },
          {
            "record_id": "asr_segment_0334",
            "source_kind": "transcript_segment",
            "start_ms": 2865340,
            "end_ms": 2867540,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "28c3f5e37c9060c89d0c45dfda3a1c9e5e8e2b8e60907fe0920e9898460ddd61"
          }
        ]
      },
      {
        "id": "topic-06",
        "title": "未来人的价值转向需求定义、系统架构和结果 review",
        "time_range": "01:00:30-01:05:16",
        "evidence": [
          {
            "record_id": "xy_timeline_021",
            "source_kind": "timeline",
            "start_ms": 3630000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "c959fef29a62621cab3441ceada81e5dcb461e2e078a00b869e9dd1262487b41"
          },
          {
            "record_id": "asr_segment_0449",
            "source_kind": "transcript_segment",
            "start_ms": 3644680,
            "end_ms": 3653420,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "6a4755e62ab783153769da06d2067caf15d545a2d8a1833e38187607f16a3c72"
          }
        ]
      }
    ],
    "core_insights": [
      {
        "id": "insight-01",
        "title": "Harness 的关键不是限制模型，而是让系统具备持续反馈与修复能力",
        "summary": "嘉宾把 Harness 描述为围绕模型、工具、安全、sandbox、host service、反馈循环等组成的动态系统，而不是单次 prompt 优化。",
        "evidence": [
          {
            "record_id": "asr_segment_0024",
            "source_kind": "transcript_segment",
            "start_ms": 162980,
            "end_ms": 173140,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "8bf5f4070ed252d864db9fcff408117bc02d9612eed27f07ecdebfc0d81190ca"
          },
          {
            "record_id": "xy_timeline_003",
            "source_kind": "timeline",
            "start_ms": 292000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "bf8ab617fd28637a487f5755998b38c6e3e37b7149b656fcf2bc3b94dcb61d35"
          }
        ],
        "confidence": "medium"
      },
      {
        "id": "insight-02",
        "title": "AI-first 的第一步是重构工作流，而不是在旧流程上添加 AI 工具",
        "summary": "节目反复区分“使用 AI 提效”和“让 AI 主导生产力系统”。前者仍受人的协作上限约束，后者要求组织流程重构。",
        "evidence": [
          {
            "record_id": "asr_segment_0091",
            "source_kind": "transcript_segment",
            "start_ms": 592960,
            "end_ms": 600000,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "a8c16a93336506391e4d6cd452bbb57dbea891f14a119a2c77ff8a78feaf2f02"
          },
          {
            "record_id": "asr_segment_0092",
            "source_kind": "transcript_segment",
            "start_ms": 600000,
            "end_ms": 609200,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "007b55fd67f0eb4f0738ccb3835011d5f6f0de10d673afc9115788154c4b3ddf"
          }
        ],
        "confidence": "high"
      },
      {
        "id": "insight-03",
        "title": "在 AI 开发流程里，planning 和 testing 需要被一起纳入 Harness",
        "summary": "当 feature implementation 只需小时级，传统长周期 design/testing 会成为瓶颈，因此 planning、testing、日志和事故信号都要进入自动反馈链。",
        "evidence": [
          {
            "record_id": "asr_segment_0090",
            "source_kind": "transcript_segment",
            "start_ms": 582140,
            "end_ms": 592660,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "c0de89d0a8501c31db66f4f6e45f1e94dce0359148f8dd7b28700b7518bc23d6"
          },
          {
            "record_id": "asr_segment_0143",
            "source_kind": "transcript_segment",
            "start_ms": 1152420,
            "end_ms": 1158360,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "43a15f90f96abd21e0a5c243f03d6dc4aaf03ecd81f32a2d2f4982270b4f4309"
          }
        ],
        "confidence": "medium"
      },
      {
        "id": "insight-04",
        "title": "组织对齐成本可能比落地成本更贵",
        "summary": "节目中多处提到 AI 让实现成本下降后，跨团队沟通、路线对齐和市场消化反而成为主要约束。",
        "evidence": [
          {
            "record_id": "asr_segment_0378",
            "source_kind": "transcript_segment",
            "start_ms": 3186500,
            "end_ms": 3196300,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "380c3ce43e5af0584b3745988c683521e7be3315c6eb53bc9b46a79e916ebbba"
          },
          {
            "record_id": "xy_timeline_008",
            "source_kind": "timeline",
            "start_ms": 841000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "c512b9e88c998dfac41397aadc85960200ab938302cc2eef4dd5574b2c28a20a"
          }
        ],
        "confidence": "high"
      },
      {
        "id": "insight-05",
        "title": "Agent 也会成为内容和产品的消费者",
        "summary": "嘉宾认为未来很多研究、购买和工具选择会先由 agent 过滤，因此产品信息、API、MCP 与可机器读取结构会变成体验的一部分。",
        "evidence": [
          {
            "record_id": "asr_segment_0209",
            "source_kind": "transcript_segment",
            "start_ms": 1856640,
            "end_ms": 1866680,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "db6f10b6c7d2aec7c5523a89002a854fa43a58d7e34022f4ba3740cea1df5fb6"
          },
          {
            "record_id": "xy_timeline_012",
            "source_kind": "timeline",
            "start_ms": 1633000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "b87b60dafe77769ee4c758c284937138d1d98d7d506105d72916f083dd154333"
          }
        ],
        "confidence": "medium"
      },
      {
        "id": "insight-06",
        "title": "产品经理角色不会消失，但会组织化和复合化",
        "summary": "节目把 PM 的传统职责拆成产品 sense、实现能力、市场判断和工程团队协作，认为角色边界会被 AI 工具压缩。",
        "evidence": [
          {
            "record_id": "asr_segment_0369",
            "source_kind": "transcript_segment",
            "start_ms": 3115400,
            "end_ms": 3120080,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "7731a85c2b54ab3cba816f2e37cdf92ca7a4507789e752644bb01ab3d05eb7cb"
          },
          {
            "record_id": "asr_segment_0370",
            "source_kind": "transcript_segment",
            "start_ms": 3120160,
            "end_ms": 3130640,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "21529fd90da4a9728a30eb18846fa8719e78814e362d99d260cd2f548e18919d"
          }
        ],
        "confidence": "medium"
      },
      {
        "id": "insight-07",
        "title": "资深工程师的价值从写代码转向发现 AI planning 的缺陷",
        "summary": "嘉宾承认 AI 写代码能力很强，但仍需要有架构经验的人判断 security、latency、agent behavior 和系统边界。",
        "evidence": [
          {
            "record_id": "asr_segment_0243",
            "source_kind": "transcript_segment",
            "start_ms": 2156200,
            "end_ms": 2159280,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "2204d7babab851d3507f3fd5abe1f78c7d7e0b9edceb9c58d081731254896237"
          },
          {
            "record_id": "asr_segment_0244",
            "source_kind": "transcript_segment",
            "start_ms": 2159540,
            "end_ms": 2160300,
            "time_accuracy": "segment_exact_asr",
            "text_sha256": "fcce0b54082f2a56e4fa62ccdc7dda69de3e107afa07752932aaa16f4372f8a1"
          }
        ],
        "confidence": "high"
      }
    ],
    "comment_signals": [
      {
        "id": "comment-signal-01",
        "title": "听众对中英文夹杂和概念表达有明显摩擦",
        "summary": "多条评论集中质疑中英文混用、表达抽象、专业词过多，这会影响节目对非一线实践者的可读性。",
        "evidence": [
          {
            "record_id": "xy_comment_001",
            "source_kind": "comment_signal",
            "start_ms": null,
            "end_ms": null,
            "time_accuracy": "char_offset_only",
            "text_sha256": "c10a1a9ed4abe8654d0f6a17afec28083091dbc60f6c99b838b9ad46bbc3bfa0"
          },
          {
            "record_id": "xy_comment_010",
            "source_kind": "comment_signal",
            "start_ms": null,
            "end_ms": null,
            "time_accuracy": "char_offset_only",
            "text_sha256": "bac9f672ceb50df87e48be29edb34dc49d4cd4549da6932abb3ef33ee5ff02b1"
          }
        ]
      },
      {
        "id": "comment-signal-02",
        "title": "听众要求更具体的产出价值和案例",
        "summary": "评论中有用户认为嘉宾回避细节、方法论多于真实产出，说明后续分析需要区分观点、案例和待验证声明。",
        "evidence": [
          {
            "record_id": "xy_comment_005",
            "source_kind": "comment_signal",
            "start_ms": null,
            "end_ms": null,
            "time_accuracy": "char_offset_only",
            "text_sha256": "a432e32e067bf42d196ec5edf2de28937bfc7757212098f3eca4b1f2b6ba6d8a"
          },
          {
            "record_id": "xy_comment_007",
            "source_kind": "comment_signal",
            "start_ms": null,
            "end_ms": null,
            "time_accuracy": "char_offset_only",
            "text_sha256": "f04262de35d2dc289ef45874058c9fa06ec564a425a64bd0e3af9f163c221b0b"
          }
        ]
      },
      {
        "id": "comment-signal-03",
        "title": "有实践经验的听众更容易进入语境",
        "summary": "部分评论认为每天使用 AI 工具链的人听起来更流畅，这提示该集更适合作为组织转型案例，而非入门解释。",
        "evidence": [
          {
            "record_id": "xy_comment_004",
            "source_kind": "comment_signal",
            "start_ms": null,
            "end_ms": null,
            "time_accuracy": "char_offset_only",
            "text_sha256": "0d0b1151e00d27f98cb7b9a84dc7d8b7a4f1cb05c0894b3f640c283d7cdb9e07"
          },
          {
            "record_id": "xy_comment_009",
            "source_kind": "comment_signal",
            "start_ms": null,
            "end_ms": null,
            "time_accuracy": "char_offset_only",
            "text_sha256": "7d80bdde2a66a9a16bfd432960fdf3eb6d71e368b5f6ff9ac00b4bb250310cf7"
          }
        ]
      }
    ],
    "verification_claims": [
      {
        "id": "claim-01",
        "claim": "节目声称 Creao 有 99% 代码由 AI 完成、每天多次部署、传统六周流程可压缩到一天。",
        "truth_status": "source_claim_unverified",
        "verification_needed": true,
        "evidence": [
          {
            "record_id": "xy_timeline_005",
            "source_kind": "timeline",
            "start_ms": 490000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "fe47b0dadfc9047cc35bc3020f30e58f357ed18fb1c32d050f1386afe944b3d4"
          }
        ]
      },
      {
        "id": "claim-02",
        "claim": "节目声称 50% 以上 issue 可通过 AutoFixing 处理。",
        "truth_status": "source_claim_unverified",
        "verification_needed": true,
        "evidence": [
          {
            "record_id": "xy_timeline_009",
            "source_kind": "timeline",
            "start_ms": 1152000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "9798a274b4f944096eb773eb9b6ea5477bfc4e88fbf46512b03075e643fecaba"
          }
        ]
      },
      {
        "id": "claim-03",
        "claim": "节目声称 2026 年 1 月用两周完成全部架构重构。",
        "truth_status": "source_claim_unverified",
        "verification_needed": true,
        "evidence": [
          {
            "record_id": "xy_timeline_014",
            "source_kind": "timeline",
            "start_ms": 1922000,
            "end_ms": null,
            "time_accuracy": "chapter_start_only",
            "text_sha256": "23b40059a97c32ba044b7c6a86d19f88d7dcdce6635fff9865e7c3be540f99a6"
          }
        ]
      }
    ],
    "product_implications": [
      "面向 agent 的产品应优先提供稳定 API/MCP、结构化任务数据和机器可读状态，而不只优化人类 dashboard。",
      "AI-first 组织的管理界面要把目标、信号、日志、回滚、review 和权限 guardrails 连接起来。",
      "内容产品如果要服务 agent reader，应为节目、观点和证据提供 record_id、hash、时间锚点和可验证声明状态。"
    ],
    "research_questions": [
      "Creao 的 AutoFixing、CI/CD 和 bug triage 系统具体如何分层授权？",
      "AI-first 组织里，哪些决策仍必须由人类 owner 批准？",
      "当产品开发速度超过市场消化速度时，如何避免 feature inventory 失控？",
      "以 agent 为内容消费者时，SEO、AEO、API 文档和内容结构应如何重构？"
    ],
    "artifacts": {
      "analysis_json": "data/episode-content/silicon-valley-101/6a13923cfe904f3873c51d2b/analysis.json",
      "analysis_markdown": "data/episode-content/silicon-valley-101/6a13923cfe904f3873c51d2b/analysis.md",
      "source_manifest_json": "data/episode-content/silicon-valley-101/6a13923cfe904f3873c51d2b/source-manifest.json",
      "source_records_jsonl": "data/episode-content/silicon-valley-101/6a13923cfe904f3873c51d2b/source-records.jsonl",
      "transcript_json": "data/episode-content/silicon-valley-101/6a13923cfe904f3873c51d2b/transcript-asr.json",
      "transcript_markdown": "data/episode-content/silicon-valley-101/6a13923cfe904f3873c51d2b/transcript-asr.md"
    }
  }
} as const;
